import apiClient from '../apiClient';
import { 
  LoginRequest, 
  VerifyOtpRequest, 
  SignupRequest, 
  AuthResponse 
} from '../../types';

const ENDPOINTS = {
  LOGIN: '/auth/login',
  VERIFY_OTP: '/auth/verify-otp',
  SIGNUP: '/auth/signup',
  LOGOUT: '/auth/logout',
  ME: '/auth/me',
  // New admin endpoint
  CREATE_ADMIN: '/admin/create-admin',
};

export const login = async (data: LoginRequest): Promise<{ success: boolean; message: string }> => {
  try {
    console.log('API Call: login with data:', data);
    const response = await apiClient.post(ENDPOINTS.LOGIN, data);
    console.log('Login API response:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('Login API error:', error.response?.data || error.message);
    // Extract error message from response if available
    const errorMessage = error.response?.data?.message || 
                         error.response?.data?.error || 
                         'User not found with this phone number';
    // Create a new error with the extracted message
    const formattedError = new Error(errorMessage);
    throw formattedError;
  }
};

export const verifyOtp = async (data: VerifyOtpRequest): Promise<AuthResponse> => {
  try {
    // Log the exact payload being sent to the server
    console.log('API Call: verifyOtp with data:', JSON.stringify(data));
    
    const response = await apiClient.post(ENDPOINTS.VERIFY_OTP, data);
    console.log('Verify OTP API response:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('Verify OTP API error:', error.response?.data || error.message);
    console.error('Error details:', {
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data
    });
    const errorMessage = error.response?.data?.message || 
                         error.response?.data?.error || 
                         error.message || 
                         'Failed to verify OTP';
    const formattedError = new Error(errorMessage);
    throw formattedError;
  }
};

export const signup = async (data: SignupRequest): Promise<{ success: boolean; message: string }> => {
  try {
    console.log('API Call: signup with data:', data);
    const response = await apiClient.post(ENDPOINTS.SIGNUP, data);
    console.log('Signup API response:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('Signup API error:', error.response?.data || error.message);
    const errorMessage = error.response?.data?.message || 
                         error.response?.data?.error || 
                         error.message || 
                         'Failed to sign up';
    const formattedError = new Error(errorMessage);
    throw formattedError;
  }
};

export const logout = async (): Promise<void> => {
  try {
    await apiClient.post(ENDPOINTS.LOGOUT);
    console.log('Logout successful');
  } catch (error: any) {
    console.error('Logout API error:', error.response?.data || error.message);
    const errorMessage = error.response?.data?.message || 
                         error.response?.data?.error || 
                         error.message || 
                         'Failed to logout';
    const formattedError = new Error(errorMessage);
    throw formattedError;
  }
};

export const getCurrentUser = async (): Promise<AuthResponse['user']> => {
  try {
    console.log('API Call: getCurrentUser');
    const response = await apiClient.get(ENDPOINTS.ME);
    console.log('Get current user API response:', response.data);
    return response.data.user;
  } catch (error: any) {
    console.error('Get current user API error:', error.response?.data || error.message);
    const errorMessage = error.response?.data?.message || 
                         error.response?.data?.error || 
                         error.message || 
                         'Failed to get user information';
    const formattedError = new Error(errorMessage);
    throw formattedError;
  }
};

// New admin-specific function
export const createAdmin = async (phone: string): Promise<{ success: boolean; message: string }> => {
  try {
    console.log('API Call: createAdmin with data:', { phone });
    const response = await apiClient.post(ENDPOINTS.CREATE_ADMIN, { phone });
    console.log('Create admin API response:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('Create admin API error:', error.response?.data || error.message);
    const errorMessage = error.response?.data?.message || 
                         error.response?.data?.error || 
                         error.message || 
                         'Failed to create admin';
    const formattedError = new Error(errorMessage);
    throw formattedError;
  }
};
